import ContentCategoryChip from '../contentcategorychip/ContentCategoryChip';

import classes from './ContentAbout.module.scss';

const ContentAbout = ({ title, description, categories }) => {
	return (
		<div className={`d-flex flex-column gap-1 gap-xl-3 ${classes['content-about-wrapper']}`}>
			<h3 className="mb-4">About the {title}</h3>
			<div className="d-none d-xl-flex flex-row flex-wrap gap-2">
				{/* {categories.map((category) => (
					<ContentCategoryChip key={category.id || category.name} {...category} />
				))} */}
			</div>
			<div
				className={`me-xl-5 me-0 ${classes['description']}`}
				dangerouslySetInnerHTML={{ __html: description }}
			></div>
		</div>
	);
};

export default ContentAbout;
